import ErrorIcon from "@mui/icons-material/Error";
import { Box, FlexColumn, FlexRowCenter, GridColumn, OverflowText, Text } from "designSystem/index";
import { black } from "designSystem/styles/color";
import React, { FunctionComponent } from "react";

/**
 * Props for the CalculationSection component.
 */
interface HintSectionProps {
	/** displays the satifaction status of the hint */
	compositionGuidanceSatisfied: string;

	/** The count of items selected. */
	count: number;

	/** color of hint */
	hint: { color: string };

	/** Title of this section */
	hintTitle: string;
}

const HintSection: FunctionComponent<HintSectionProps> = ({ compositionGuidanceSatisfied, count, hint, hintTitle }) =>{
	return (
		<FlexColumn sx={{ height: "auto" }}>
			<Box mb={8}>
				<OverflowText res="DialogSelectionOverview" variant="h4" />
			</Box>
			{!count && (
				<FlexRowCenter>
					<OverflowText
						bold
						res="DialogSelectionEmpty"
						sx={{ color: black[500] }}
					/>
				</FlexRowCenter>
			)}
			{!!count && (
				<GridColumn>
					<OverflowText
						bold
						res={hintTitle}
						sx={{ color: black[500] }}
					/>
					<FlexRowCenter>
						<ErrorIcon 
							sx={{ 
								...hint,
								margin: "12px 8px 12px 0",
							}} 
						/>
						<Text res={compositionGuidanceSatisfied} sx={{ ...hint }} />
					</FlexRowCenter>
				</GridColumn>
			)}
		</FlexColumn>
	);
};

export default HintSection;